export const tr = {
    'drop-files-here': 'Banner dosyalarını buraya sürükleyin',
    'press-upload': 'veya "Yükle"ye tıklayın. Yüklemeden önce {requirementsLink} inceleyin.',
    requirements: 'teknik koşulları',
    upload: 'Yükle'
};
